import { createFileRoute } from '@tanstack/react-router';

import { staticPageHead } from '@/config/seo-head';
import { HomeProjectsPage } from '@/features/projects/components/home-projects-page';
import { loadFeaturedProjects } from '@/features/projects/project-loaders';

export const Route = createFileRoute('/')({
  head: () => staticPageHead('/'),
  loader: () => loadFeaturedProjects(),
  component: HomeRoute,
});

function HomeRoute() {
  const featuredProjects = Route.useLoaderData();
  return <HomeProjectsPage featuredProjects={featuredProjects} />;
}
